var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "154px",
    height: "154px",
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1DB954",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 72,
    style: {
      strokeDasharray: "480px, 480px",
      strokeDashoffset: 960
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "colored",
    fill: "#1DB954",
    cx: 77,
    cy: 77,
    r: 72,
    style: {
      strokeDasharray: "480px, 480px",
      strokeDashoffset: 960
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#fff",
    strokeWidth: 10,
    points: "43.5,77.8 63.7,97.9 112.2,49.4 ",
    style: {
      strokeDasharray: "100px, 100px",
      strokeDashoffset: 200
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.b920a445b51c1650fd13748f282b8808.svg";
export { ForwardRef as ReactComponent };